import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import PillsMenu from '@app/components/teachers/PillsMenu'
import ClassesContainer from '@app/containers/teachers/Classes'
import Loader from '@app/components/ui/placeholders/Loader'
import { Teacher } from '@app/models/users'
import { sortedClasses } from '@app/helpers/classesHelper'
import Row from '@app/components/teachers/Classes/Row'
import _ from 'lodash'

const Content = ({ classes }) => {
  const { fetching } = classes
  if (fetching) { return <Loader /> }

  return (
    <Fragment>
      <div className="page__inner">
        <div className="grid grid--sm-1 grid--md-2 grid--xl-3">
          {
            _.map(sortedClasses(classes.objects), (group) => {
              return <Row
                key={group.object.id}
                group={group}
                href={`/teachers/classes/${group.object.id}/statistics`}
              />
            })
          }
        </div>
      </div>
    </Fragment>
  )
}

const Statistics = ({ teacher, route }) => {
  return (
    <Fragment>
      <div className="page__inner mt-2" style={{ marginBottom: '16px' }}>
        <h1 className="plate-heading plate-heading--left m-0" style={{ color: 'rgba(9, 21, 38, .85)' }}>
          { I18n.t('teachers.show.statistic') }
        </h1>
      </div>
      <ClassesContainer ChildComponent={Content} route={route} />
    </Fragment>
  )
}

Statistics.propTypes = {
  route: PropTypes.object.isRequired,
  teacher: PropTypes.instanceOf(Teacher).isRequired
}

export default Statistics
